import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en.json";
import arTranslation from "./locales/ar.json";
import esTranslation from "./locales/es.json";
import faTranslation from "./locales/fa.json";
import hyTranslation from "./locales/hy.json";
import ruTranslation from "./locales/ru.json";
import tlTranslation from "./locales/tl.json";
import zhCNTranslation from "./locales/zh-CN.json";
import koTranslation from "./locales/ko.json";
import hiGujTranslation from "./locales/hi-Guj.json";

const resources = {
    en: { translation: enTranslation },
    ar: { translation: arTranslation },
    es: { translation: esTranslation },
    fa: { translation: faTranslation },
    hy: { translation: hyTranslation },
    ru: { translation: ruTranslation },
    tl: { translation: tlTranslation },
    "zh-CN": { translation: zhCNTranslation },
    ko: { translation: koTranslation },
    "hi-Guj": { translation: hiGujTranslation },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
        },
    });

export default i18n;